import { ROUTES } from "@Src/constants/Routes";

const handleExternalRedirect = (targetUrl) => {
  const url = ROUTES.REDIRECT_ROUTE;
  window.localStorage.setItem("ruri", encodeURIComponent(targetUrl));
  window.open(url, "external_url");
};

/**
 * Handles the redirection to an interstitial page by encoding the provided
 * store data, saving it to localStorage, and opening a new window with the
 * interstitial page URL.
 *
 * @param {Object} storeData - The data to be stored and passed to the interstitial page.
 * @returns {void}
 */
const handleInterstitialRedirect = (storeData) => {
  const url = ROUTES.REDIRECT_ROUTE;
  const encodedData = encodeURIComponent(JSON.stringify(storeData));
  window.localStorage.setItem("interstitial_data", encodedData);
  window.open(url, "interstitial_page");
};

export { handleExternalRedirect, handleInterstitialRedirect };
